import './style.css';

import React from 'react';

import { Dialog, Button } from '@economic/taco';
import Icon from '../../../../../../shared/components/ui/primitives/Icon';
import { t } from '../../../../../../shared/components/l10n/l10n';
import { DisplayMessages } from '../../../shared/components/DisplayMessages';
import { InvoicingMessage } from '../types';

interface Props {
    open: boolean;
    hide: () => void;
    messages: InvoicingMessage[];
    hasError?: boolean;
}

export default function MoneyflowInvalidOfferDialogComponent({ open, hide, messages, hasError }: Props) {
    const state = hasError ? 'error' : 'information';

    return (
        <Dialog open={open} onClose={hide}>
            <Dialog.Content aria-label={t`FORM_BOOKANDSEND_MONEYFLOW_HEADER_NOTQUALIFIED`} className="moneyflow-dialog">
                <Dialog.Title>
                    <Icon
                        name="warning"
                        badge={state}
                        className={state === 'error' ? 'moneyflow-dialog-header--error' : 'moneyflow-dialog-header--info'}
                        aria-label={t`FORM_BOOKANDSEND_MONEYFLOW_HEADER_NOTQUALIFIED`}
                    />
                </Dialog.Title>

                <p className="moneyflow-dialog__sub-header">{t`FORM_BOOKANDSEND_MONEYFLOW_HEADER_NOTQUALIFIED`}</p>
                <div className="moneyflow-dialog__messages">
                    <DisplayMessages messages={messages} />
                </div>

                <Dialog.Footer>
                    <Button appearance="primary" onClick={hide}>{t`SHARED_FORM_OK`}</Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}
